import {Language} from "../../config/LanguageConfig";

export interface SelectLanguageAction {
    type: typeof SELECT_LANGUAGE
    lang: Language
}

export type LanguageActionTypes = SelectLanguageAction

export const SELECT_LANGUAGE = "SELECT_LANGUAGE";

export const selectLanguage = ( lang: Language ): SelectLanguageAction => ({ type: SELECT_LANGUAGE, lang });
